import { SYS_BORDER_RADIUS_MD, SYS_BREAKPOINT_LG } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
export const Placeholder = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  aspect-ratio: 16 / 9;
  color: ${({ theme }) => theme.sys.color.text.copy.default};
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.sys.color.elevation.level3.fill.stops[0]} 0%,
    ${({ theme }) => theme.sys.color.elevation.level3.fill.stops[100]} 100%
  );
  margin-left: auto;
  border-radius: ${SYS_BORDER_RADIUS_MD};

  @media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
    ${(props) => !props.$compare &&
    `
      margin-left: auto;
    `}
  }
`;
export const Image = styled.img `
  width: 100%;
  aspect-ratio: 16 / 9;

  @media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
    ${(props) => !props.$compare &&
    `
      margin-left: auto;
      max-width: inherit;
    `}
  }
`;
